<template>
  <div>
    <!-- Header -->
    <div class="content-header row">
      <div class="content-header-left col-md-6 col-12 mb-2">
        <div class="row breadcrumbs-top">
          <div class="breadcrumb-wrapper col-12">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboard' }">Inicio</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'catalogo' }">Catálogo</router-link>
              </li>
              <li class="breadcrumb-item active">Referencias de Obras</li>
            </ol>
          </div>
        </div>
        <h3 class="content-header-title mb-0">Gestión de Referencias de Obras</h3>
      </div>
      <div class="content-header-right col-md-6 col-12">
        <div class="btn-group float-md-right" role="group">
          <b-button
            variant="primary"
            @click="showModal = true"
            v-b-modal.modal-referencia-obra
          >
            <feather-icon icon="PlusIcon" class="mr-50" />
            Nueva Referencia
          </b-button>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Lista de Referencias de Obras</h4>
          </div>
          <div class="card-content">
            <div class="card-body">
              <!-- Indicador de carga -->
              <div v-if="cargando" class="text-center py-4">
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only">Cargando...</span>
                </div>
                <p class="mt-2">Cargando referencias de obras...</p>
              </div>

              <!-- Tabla de datos -->
              <div v-else class="table-responsive">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Nombre</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="referenciasObras.length === 0">
                      <td colspan="3" class="text-center py-4">
                        <p class="mb-0">No hay referencias de obras registradas</p>
                      </td>
                    </tr>
                    <tr v-for="referencia in referenciasObras" :key="referencia.idReferenciaObra">
                      <td>{{ referencia.idReferenciaObra }}</td>
                      <td>{{ referencia.nombre }}</td>
                      <td>
                        <div class="btn-group" role="group">
                          <b-button
                            variant="outline-primary"
                            size="sm"
                            @click="editarReferencia(referencia)"
                          >
                            <feather-icon icon="EditIcon" size="14" />
                          </b-button>
                          <b-button
                            variant="outline-danger"
                            size="sm"
                            @click="eliminarReferencia(referencia.idReferenciaObra)"
                          >
                            <feather-icon icon="TrashIcon" size="14" />
                          </b-button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal para crear/editar -->
    <b-modal
      id="modal-referencia-obra"
      :title="modoEdicion ? 'Editar Referencia de Obra' : 'Nueva Referencia de Obra'"
      @show="limpiarFormulario"
      @hidden="limpiarFormulario"
    >
      <b-form @submit.prevent="guardarReferencia">
        <b-form-group label="Nombre:" label-for="nombre">
          <b-form-input
            id="nombre"
            v-model="formulario.nombre"
            type="text"
            placeholder="Ingrese el nombre de la referencia"
            required
          />
        </b-form-group>
      </b-form>

      <template #modal-footer>
        <b-button variant="secondary" @click="$bvModal.hide('modal-referencia-obra')">
          Cancelar
        </b-button>
        <b-button
          variant="primary"
          @click="guardarReferencia"
          :disabled="guardando"
        >
          <span v-if="guardando" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
          {{ modoEdicion ? 'Actualizar' : 'Crear' }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { BButton, BModal, BForm, BFormGroup, BFormInput } from 'bootstrap-vue'
import { CatalogoReferenciasObrasMixin } from '@/@core/mixins/catalogos'

export default {
  name: 'CatalogoReferenciasObras',
  components: {
    BButton,
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
  },
  mixins: [CatalogoReferenciasObrasMixin],
}
</script>